// extracted by mini-css-extract-plugin
export default {"container":"eLX19DLVCk","name":"JKJk_fBreu","image":"tgAR0bDWrb","info":"Nb8DFgJMhC","info-item":"V_T86WF6j1","infoItem":"V_T86WF6j1","description":"_GQeAxAjfL","links":"NuyXJD2AdV"};